import React from 'react';
import PropTypes from 'prop-types';

const Email = ({ fill = 'var(--SECONDARY_DARK)' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V13.5C1.5 13.8978 1.65804 14.2794 1.93934 14.5607C2.22064 14.842 2.60218 15 3 15H15C15.3978 15 15.7794 14.842 16.0607 14.5607C16.342 14.2794 16.5 13.8978 16.5 13.5V4.5C16.5 4.10218 16.342 3.72064 16.0607 3.43934C15.7794 3.15804 15.3978 3 15 3ZM14.25 13.5H3.75C3.55109 13.5 3.36032 13.421 3.21967 13.2803C3.07902 13.1397 3 12.9489 3 12.75V6L8.205 9.255C8.4434 9.404 8.71887 9.483 9 9.483C9.28113 9.483 9.5566 9.404 9.795 9.255L15 6V12.75C15 12.9489 14.921 13.1397 14.7803 13.2803C14.6397 13.421 14.4489 13.5 14.25 13.5ZM9 8.25L3 4.5H15L9 8.25Z"
      fill={fill}
    />
  </svg>
);

Email.propTypes = {
  fill: PropTypes.string,
};

export default Email;
